import React from 'react'

class PageHeading extends React.Component {
	render() {
		const { heading } = this.props
		return (
			<h2 className="page-heading">{ heading }</h2>
		)
	}
}

export default PageHeading


// WEBPACK FOOTER //
// ./src/components/Global/PageHeading.js